import { Component } from '@angular/core';

@Component({
  selector: 'mprd-internet-available-options-skeleton',
  templateUrl: './internet-available-options-skeleton.component.html',
})
export class InternetAvailableOptionsSkeletonComponent {
  constructor() {}
}
